import { type PartialDeep } from 'type-fest';

import { type CanvasElementFrom } from '@blaze-runtime/engine-domain';

import { type DefinitionMapper } from '../../../ai';
import { toHeightStyle, toWidthStyle } from '../../../ai/models/styles';

import { type TextAreaDefinition } from './text-area.definition';

export class TextAreaDefinitionMapper implements DefinitionMapper<'textArea'> {
  readonly type = 'textArea';

  extract(element: CanvasElementFrom<'textArea'>): PartialDeep<TextAreaDefinition> {
    const content = element.props.content;

    return {
      text: content.input?.value,
      styleName: element.props.styleConfig?.styleName,
      width: toWidthStyle(element.width),
      height: element.height ? toHeightStyle(element.height) : undefined,
    };
  }
}
